const swiper = new Swiper('.testimonials-ticker', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 10,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,

  },

  breakpoints: {
    768: {
      slidesPerView: 4
    },
    1024: {
      slidesPerView: 5
    },
  }
});